"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/**
 * Copyright (c) Qwoach LLC 2020. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 7/26/19
 *
 */

module.exports = /*#__PURE__*/function () {
  function FirestorePager(ref, dataFilter, clazz, resArrayToDataArrayFn, options) {
    (0, _classCallCheck2["default"])(this, FirestorePager);
    this.loadCounter = 0;
    this.hasMore = true;
    this.isDebugEnabled = true;
    this.clazz = clazz;
    this.ref = ref;
    this.dataFilter = dataFilter;
    this.resArrayToDataArrayFn = resArrayToDataArrayFn;
    this.options = options;
    this.extraDataFilter = null;
  }
  (0, _createClass2["default"])(FirestorePager, [{
    key: "setExtraDataFilter",
    value: function setExtraDataFilter(extraDataFilter) {
      this.extraDataFilter = extraDataFilter;
    }

    // indicates if the previous load was initial.
    // "false" means the last operation was "loadMore"
  }, {
    key: "isInitialLoad",
    value: function isInitialLoad() {
      // this.log("Pager.isInitialLoad: this.loadCounter = ", this.loadCounter)
      return this.loadCounter <= 1;
    }
  }, {
    key: "mergeData",
    value: function mergeData(dataFull, newData) {
      // this.log("Pager.mergeData: newData = ", newData, ", dataFull = ", dataFull, ", this.isInitialLoad() = ", this.isInitialLoad())
      if (this.isInitialLoad()) {
        this.removeAllElements(dataFull);
      }
      dataFull.push.apply(dataFull, (0, _toConsumableArray2["default"])(newData));
      return dataFull;
    }
  }, {
    key: "removeAllElements",
    value: function removeAllElements(arr) {
      while (arr.length) {
        arr.pop();
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this.lastDoc = null;
      this.loadCounter = 0;
      this.hasMore = true;
      return this;
    }
  }, {
    key: "createQuery",
    value: function createQuery() {
      var nextQuery = this.ref;
      var dataFilter = this.dataFilter;
      if (this.extraDataFilter) {
        dataFilter = this.extraDataFilter.merge(dataFilter);
      }
      nextQuery = dataFilter.applyFilters(nextQuery);
      nextQuery = nextQuery.limit(this.getLimit());
      if (this.lastDoc) {
        nextQuery = nextQuery.startAfter(this.lastDoc);
      }
      return nextQuery;
    }
  }, {
    key: "loadAll",
    value: function () {
      var _loadAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var res, data;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              res = [];
              this.reset();
            case 2:
              if (!this.hasMore) {
                _context.next = 9;
                break;
              }
              _context.next = 5;
              return this.next();
            case 5:
              data = _context.sent;
              res.push.apply(res, (0, _toConsumableArray2["default"])(data));
              _context.next = 2;
              break;
            case 9:
              return _context.abrupt("return", res);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function loadAll() {
        return _loadAll.apply(this, arguments);
      }
      return loadAll;
    }()
  }, {
    key: "next",
    value: function () {
      var _next = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
        var nextQuery, res;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.loadCounter++;
              // this.log("Pager.next: this.loadCounter = ", this.loadCounter)
              if (this.hasMore) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return", []);
            case 3:
              nextQuery = this.createQuery();
              _context2.next = 6;
              return nextQuery.get();
            case 6:
              res = _context2.sent;
              return _context2.abrupt("return", this.processResult(res));
            case 8:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function next() {
        return _next.apply(this, arguments);
      }
      return next;
    }()
  }, {
    key: "processResult",
    value: function processResult(res) {
      if (res.docs.length < this.getLimit()) {
        this.hasMore = false;
      } else {
        this.lastDoc = res.docs[res.docs.length - 1];
      }
      var lastChunk = this.resArrayToDataArrayFn(res, this.clazz, this.options);
      // this.log("Pager: lastChunk = ", lastChunk)
      return lastChunk;
    }
  }, {
    key: "getLimit",
    value: function getLimit() {
      return this.dataFilter.getLimit() || 1000;
    }
  }, {
    key: "log",
    value: function log() {
      if (this.isDebugEnabled) {
        var _console;
        (_console = console).log.apply(_console, arguments);
      }
    }
  }, {
    key: "logWarn",
    value: function logWarn() {
      if (this.isDebugEnabled) {
        var _console2;
        (_console2 = console).warn.apply(_console2, arguments);
      }
    }
  }]);
  return FirestorePager;
}();